import { ref, onMounted, onUnmounted, type Ref } from 'vue'

/**
 * Composable für Scroll-basierte Animationen mit Intersection Observer
 * Best Practice: Elemente animieren nur wenn sie im Viewport sichtbar werden
 */
export function useScrollAnimation(options: {
  threshold?: number
  rootMargin?: string
  triggerOnce?: boolean
} = {}) {
  const {
    threshold = 0.1,
    rootMargin = '0px 0px -100px 0px',
    triggerOnce = true
  } = options

  const isVisible = ref(false)
  const targetElement: Ref<HTMLElement | null> = ref(null)
  let observer: IntersectionObserver | null = null

  onMounted(() => {
    if (!targetElement.value || typeof window === 'undefined' || !('IntersectionObserver' in window)) {
      // Fallback: Sofort sichtbar machen wenn IntersectionObserver nicht verfügbar
      isVisible.value = true
      return
    }

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            isVisible.value = true
            
            // Nur einmal triggern, dann Observer beenden
            if (triggerOnce && observer && targetElement.value) {
              observer.unobserve(targetElement.value)
            }
          } else if (!triggerOnce) {
            // Wenn nicht triggerOnce, dann bei Verlassen wieder ausblenden
            isVisible.value = false
          }
        })
      },
      {
        threshold,
        rootMargin
      }
    )

    observer.observe(targetElement.value)
  })

  onUnmounted(() => {
    if (observer && targetElement.value) {
      observer.unobserve(targetElement.value)
      observer.disconnect()
    }
  })

  return {
    isVisible,
    targetElement
  }
}












